import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent implements OnInit {
  @Input () inputValue : string = "";
  @Input () label : string;
  @Input () textareaHeight : string;
  @Input () name : string;
  @Input () id : string;
  @Input () isDisable : boolean = false;
  @Input () isRequired : boolean = false;
  @Input() textareaClass:string;
  @Output() inputValueEmit:EventEmitter<string> = new EventEmitter();
  @Input () clearValue : boolean = false;
  @Input () maxlength : number;
  @Input () rows : number = 10;

  
  constructor() { }

  ngOnInit(): void {
  }

}
